import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Parses an event date string (YYYY-MM-DD) and returns a Date object
 * that represents that date in local timezone (ignoring UTC conversion issues).
 * 
 * Fixes the bug where new Date("2025-12-15") is interpreted as midnight UTC,
 * which in BRT (UTC-3) shows as December 14th at 21:00.
 */
export function parseEventDate(dateString) {
  if (!dateString) return null;

  // If already a Date object, just extract the date parts
  if (dateString instanceof Date) {
    const year = dateString.getFullYear();
    const month = dateString.getMonth();
    const day = dateString.getDate();
    return new Date(year, month, day, 12, 0, 0); // noon to avoid edge cases
  }

  // For string YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss, create Date with local components
  const datePart = String(dateString).split('T')[0];
  const [year, month, day] = datePart.split('-').map(Number);
  return new Date(year, month - 1, day, 12, 0, 0); // noon to avoid edge cases
}
